import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import { palette } from "../../../theme/palette";

import { driverEditModeSelector } from "../../../reducers/driverManagement/selectors";
import {
  setAddDriverModalOpen,
  setSelectedDriver,
} from "../../../reducers/ownApp";
import { getSelectedDepot } from "../../../reducers/ownApp/selectors";

import DepotSummary from "../../DepotSummary";
import LockComponent from "./LockComponent";
import { View } from "../../View";
import { ActionButton } from "../Common/ActionButton";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: typography.pxToRem(30),
    width: "100vw",
    backgroundColor: palette.transparent,
  },
  rightActions: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
  },
  leftContent: {
    display: "inline-block",
  },
}));

export const Subheader = () => {
  const dispatch = useDispatch();
  const selectedDepot = useSelector(getSelectedDepot);
  const driverEditMode = useSelector(driverEditModeSelector);
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View className={styles.leftContent}>
        <DepotSummary />
      </View>
      <View className={styles.rightActions}>
        <View>
          {selectedDepot && (
            <ActionButton
              variant={"yellow"}
              disabled={driverEditMode}
              onClick={() => {
                dispatch(setAddDriverModalOpen(true));
                dispatch(setSelectedDriver(null));
              }}
            >
              + Add New Driver
            </ActionButton>
          )}
        </View>
        <LockComponent />
      </View>
    </View>
  );
};
